import {
  getApiV2CustomersCustomerIdAddress,
  type Address,
} from '@hungryroot/rest/api/v2/customers/[id]/address/get';
import {
  patchApiV2CustomersCustomerIdAddress,
  type PatchedAddress as AddressRequestBody,
} from '@hungryroot/rest/api/v2/customers/[id]/address/patch';

export type { Address, AddressRequestBody };

export async function getCustomerAddress() {
  const resp: { status: number; data: Address } =
    await getApiV2CustomersCustomerIdAddress();

  const { status, data } = resp;

  if (status === 200) {
    return data;
  }

  throw data;
}

export async function saveAddressV2({
  address,
}: {
  address: AddressRequestBody;
}) {
  const resp: {
    status: number;
    data: Address;
    msg_id?: string;
    detail?: string;
  } = await patchApiV2CustomersCustomerIdAddress({
    requestBody: address,
  });

  if (resp.status === 200) {
    return resp;
  }

  throw resp.data;
}
